import React from 'react';
import { Button } from 'antd';

export const PrimaryButton = (props) => (
  <Button
    {...props}
    type='primary'
    className={`uppercase ${props.className}`}
  >
    {props.label}
  </Button>
);
